// AP CRM

var companyNames;

$(document).ready(function() {
	
	$('#ob_companyName').on('input', Foundation.util.throttle(function(e) {
		search(e);
	// Foundation - throttle the event handler, 500ms
	}, 500));

		$('#ob_contactSelect').on('change', function(e) {
		var contactId = $(e.currentTarget).val();
		populateContactInfo(contactId);
		$('#contactId').val(contactId);
	});
	
	$('#onboard-form').submit(function(e) {
		e.preventDefault();
		onboard(e);
	});
	
	$('#resync-ap').on('click', function(e) {
		resync();
	});
	
	$('#disconnect-ap').on('click', function(e) {
		disconnect();
	});
	
	$('#paste-company-name').on('click', function(e) {
		pasteCompanyName(e);
	});
	
	$('#connect-form').submit(function(e) {
		e.preventDefault();
		connect(e);
	});
	
});

function search(e) {

	var $search = $(e.currentTarget);

	var $count = $('#suggestions-count');
	var $suggestionsBox = $('#suggestions');	
	
	$suggestionsBox.hide()
	$('#ob_contactSelect').closest('.cell').addClass('hide');
	
	if (($search.val()).length < 3) {
		$count.html('<p>Minimum of 3 characters required.</p>');
		return;
	}

	$.ajax({
		url: '/ajax/ap/get-companies',
		method: 'POST',
		data: JSON.stringify({
			search: $('#ob_companyName').val()
		}),
		contentType: 'application/json',
		success: function(data) {		
			var count = data.totalCount;
			
			$suggestionsBox.empty();
			
			$count.show();
			
			if (count > 200) {
				$count.html('<p>Too many results found. Please be more specific to narrow down your search.</p>');
				return;
			} else if (count == 0) {
				$suggestionsBox.hide();
				$count.html('<p>No results found.</p>');
			} else {
				$suggestionsBox.show();
				$count.html('<p>' + count + ' result' + (count !== 1 ? 's' : '') + '</p>');
			}
			
			companyNames = {};
			$.each(data.response, function(index, company) {
				companyNames[company.CompanyID] = company.RegisteredName;
			});

			var input = $search.val().toLowerCase();

			if (input.length > 0) {
				var filteredCompanies = $.map(companyNames, function(name, id) {
					if (name.toLowerCase().includes(input.toLowerCase())) {
						return { id: id, name: name };
					}
				});
			}

			// Display filtered suggestions
			$.each(filteredCompanies, function(index, company) {
				var suggestion = $('<div>')
					.addClass('autocomplete-suggestion')
					.text(company.name)
					.data('id', company.id)
					.on('click', function() {
						$('#ob_companyName').val(company.name);
						$suggestionsBox.empty().hide();

						// Call the AJAX function to fetch contacts
						fetchContacts(company.id);
						$count.hide();
					});

				$suggestionsBox.append(suggestion);
			});
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

function fetchContacts(companyId) {
	$('input[name="onboard-client"]').addClass('disabled').attr('disabled');
	$('input[name="connect-client"]').addClass('disabled').attr('disabled');
	$('#contact-info').hide();
	$('#missing-info-wrapper').hide();
	$.ajax({
		url: '/ajax/ap/get-company-contacts',
		method: 'POST',
		data: JSON.stringify({
			companyId: companyId
		}),
		contentType : 'application/json',
		success: function(data) {
			populateContactSelect(data);
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
				alert(response.error);
			}
	});
}

function populateContactSelect(contacts) {
	var $select = $('#ob_contactSelect');
	$select.closest('.cell').removeClass('hide');
	$select.empty(); // Clear previous options
	$select.append('<option disabled value=\"\" selected>-- Select a contact --</option>');

	$.each(contacts, function(index, contact) {
		var option = $('<option>')
			.val(contact.ContactID) 
			.text(contact.Forename + ' ' + contact.Surname);
		$select.append(option);
	})
}

function populateContactInfo(contactId) {
	$('input[name="onboard-client"]').removeAttr('disabled').removeClass('disabled');
	$('input[name="connect-client"]').removeAttr('disabled').removeClass('disabled');
	
	var $contactInfo = $('#contact-info');
	
	$contactInfo.hide();
	$('#missing-info-wrapper').hide();
			
	$('#ob_sbi, #ob_addressRegion, #ob_sfiToggle').closest('.cell').addClass('hide');
	$.ajax({
		url: '/ajax/ap/get-company-contact',
		method: 'POST',
		data: JSON.stringify({
			contactId: contactId
		}),
		contentType: 'application/json',
		success: function(data) {
			$contactInfo.find('div').empty();
			// Extract relevant fields
			var title = data.Title || null;
			var forename = data.Forename || null;
			var surname = data.Surname || null;
			var email = data.Emails.length > 0 ? data.Emails[0].Email : null;
			var addressSummary = data.Addresses.Company ? data.Addresses.Company.AddressSummary : null;
			var telephone = data.Telephone || null;
			var registeredDate = new Date(data.RegisteredDate).toLocaleDateString();

			// Create a formatted output
			var contactInfoHtml = '<div class="cell small-12">' +
				'<p><strong>Title:</strong> ' + title + '</p>' +
				'<p><strong>Forename:</strong> ' + forename + '</p>' +
				'<p><strong>Surname:</strong> ' + surname + '</p>' +
				'<p><strong>Email:</strong> ' + email + '</p>' +
				'<p><strong>Address Summary:</strong> ' + addressSummary + '</p>' +
				'<p><strong>Telephone:</strong> ' + telephone + '</p>' +
				'<p><strong>Registered Date:</strong> ' + registeredDate + '</p></div>';

			$contactInfo.show().find('div').html(contactInfoHtml);
			
			$('#missing-info-wrapper').show();
			$('#ob_sbi, #ob_addressRegion, #ob_sfiToggle').closest('.cell').removeClass('hide');
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

/**
* Onboard
*
* Onboard client from AP CRM
*/
function onboard(e) {
	var $form = $(e.currentTarget);
	$.ajax({
		url: '/ajax/ap/onboard',
		method: 'POST',
		data: JSON.stringify($form.serializeObject()),
		contentType: 'application/json',
		success: function(data) {
			window.location.replace(data.url)
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

/**
* Resync
*
* Resync client with AP CRM
*/
function resync() {
	var clientId = $('#ap-data').data('client-id');
	var contactId = $('#ap-data').data('ap-contact-id');
	var companyId = $('#ap-data').data('ap-company-id');
	$.ajax({
		url: '/ajax/ap/sync',
		method: 'POST',
		data: JSON.stringify({
			clientId: clientId,
			contactId: contactId,
			companyId: companyId
		}),
		contentType: 'application/json',
		success: function(data) {
			window.location.reload();
			window.scrollTo(0, 0);
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

/**
* Disconnect
*
* Disconnect client from AP CRM
*/
function disconnect() {
	var clientId = $('#ap-data').data('client-id');
	$.ajax({
		url: '/ajax/ap/disconnect',
		method: 'POST',
		data: JSON.stringify({
			clientId: clientId
		}),
		contentType: 'application/json',
		success: function(data) {
			window.location.reload();
			window.scrollTo(0, 0);
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

/**
* pasteCompanyName
*
*/
function pasteCompanyName(e) {
	var clientId = $(e.currentTarget).data('client-id');
	$.ajax({
		url: '/ajax/clients/get-business-name',
		method: 'POST',
		data: JSON.stringify({
			c: clientId
		}),
		contentType: 'application/json',
		success: function(data) {
			$('#ob_companyName').val(data.businessName).trigger("input");
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}

/**
* Connect
*
* Connect client with AP CRM
*/
function connect(e) {
	var $form = $(e.currentTarget);
	$.ajax({
		url: '/ajax/ap/connect',
		method: 'POST',
		data: JSON.stringify($form.serializeObject()),
		contentType: 'application/json',
		success: function(data) {
			window.location.replace(data.url)
		},
		error: function(xhr, status, error) {
			var response = JSON.parse(xhr.responseText);
			alert(response.error);
		}
	});
}